import React, { useState } from 'react';

const AccountantSocFundTransferList = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [monthYear, setMonthYear] = useState('');

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-[98%] mx-auto bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        {/* Header Section */}
        <div className="px-6 py-4 flex justify-between items-center border-b border-gray-100">
          <h1 className="text-xl font-bold text-gray-800 tracking-tight">Payment Details</h1>
          <div className="text-sm text-gray-500">
            ठाणे जिल्हा परिषद / <span className="text-gray-400">Payment Details</span>
          </div>
        </div>

        {/* Filters Section */}
        <div className="p-6">
          <div className="flex flex-wrap items-end gap-6 mb-8">
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-bold text-gray-700 uppercase tracking-wider">From Date <span className="text-red-500">*</span></label>
              <input 
                type="date" 
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="border border-gray-300 rounded px-3 py-2 text-gray-600 focus:outline-none focus:border-blue-500 w-48 shadow-sm transition-all"
                placeholder="dd-mm-yyyy"
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-bold text-gray-700 uppercase tracking-wider">To Date <span className="text-red-500">*</span></label>
              <input 
                type="date" 
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="border border-gray-300 rounded px-3 py-2 text-gray-600 focus:outline-none focus:border-blue-500 w-48 shadow-sm transition-all"
                placeholder="dd-mm-yyyy"
              />
            </div>
            <div className="flex items-center pb-2.5 text-red-600 font-bold px-2">
              OR
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-bold text-gray-700 uppercase tracking-wider">Month & Year <span className="text-red-500">*</span></label>
              <input 
                type="month" 
                value={monthYear}
                onChange={(e) => setMonthYear(e.target.value)}
                className="border border-gray-300 rounded px-3 py-2 text-gray-600 focus:outline-none focus:border-blue-500 w-48 shadow-sm transition-all"
              />
            </div>
            <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-8 rounded transition-all shadow-md transform active:scale-95">
              Search
            </button>
          </div>

          {/* Table Section */}
          <div className="overflow-x-auto border border-gray-200 rounded-lg shadow-sm">
            <table className="w-full text-left border-collapse min-w-[1200px]">
              <thead>
                <tr className="bg-white text-gray-800 text-xs font-bold uppercase tracking-wider">
                  <th className="px-4 py-4 border-b border-r border-gray-200">Sr.No.</th>
                  <th className="px-4 py-4 border-b border-r border-gray-200">Date</th>
                  <th className="px-4 py-4 border-b border-r border-gray-200">Fund Transactions ID</th>
                  <th className="px-4 py-4 border-b border-r border-gray-200">Amount</th>
                  <th className="px-4 py-4 border-b border-r border-gray-200">No.</th>
                  <th className="px-4 py-4 border-b border-r border-gray-200">Society Name</th>
                  <th className="px-4 py-4 border-b border-r border-gray-200">GST No.</th>
                  <th className="px-4 py-4 border-b border-r border-gray-200">Tender Fee</th>
                  <th className="px-4 py-4 border-b border-r border-gray-200">GST</th>
                  <th className="px-4 py-4 border-b border-r border-gray-200">Total</th>
                  <th className="px-4 py-4 border-b border-r border-gray-200">Service Charge</th>
                  <th className="px-4 py-4 border-b">Remark</th>
                </tr>
              </thead>
              <tbody>
                {/* Grand Total Row */}
                <tr className="bg-slate-50 font-bold text-gray-900 border-t border-gray-300">
                  <td className="px-4 py-5 border-r border-gray-200" colSpan={7}>Grand Total</td>
                  <td className="px-4 py-5 border-r border-gray-200">0.00</td>
                  <td className="px-4 py-5 border-r border-gray-200">0.00</td>
                  <td className="px-4 py-5 border-r border-gray-200">0.00</td>
                  <td className="px-4 py-5 border-r border-gray-200"></td>
                  <td className="px-4 py-5"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountantSocFundTransferList;
